export const CATEGORY_COLORS = [
  { bg: "#eef2ff", border: "#c7d2fe", pill: "#e0e7ff", text: "#3730a3" }, // indigo
  { bg: "#f0f9ff", border: "#bae6fd", pill: "#e0f2fe", text: "#0c4a6e" }, // sky
  { bg: "#fefce8", border: "#fef08a", pill: "#fef9c3", text: "#713f12" }, // yellow
  { bg: "#fff7ed", border: "#fed7aa", pill: "#ffedd5", text: "#9a3412" }, // orange
  { bg: "#f5f3ff", border: "#ddd6fe", pill: "#ede9fe", text: "#4c1d95" }, // violet
  { bg: "#fdf2f8", border: "#f9a8d4", pill: "#fce7f3", text: "#831843" }, // pink
  { bg: "#ecfeff", border: "#a5f3fc", pill: "#cffafe", text: "#164e63" }, // cyan
  { bg: "#f0fdf4", border: "#bbf7d0", pill: "#dcfce7", text: "#14532d" }, // green
  { bg: "#fff1f2", border: "#fecdd3", pill: "#ffe4e6", text: "#881337" }, // rose
];

export const CATEGORY_GRADIENTS = [
  "linear-gradient(135deg,#a1c4fd,#4facfe)",   // 0 — sky blue
  "linear-gradient(135deg,#4facfe,#0891b2)",   // 1 — cyan
  "linear-gradient(135deg,#86efac,#16a34a)",   // 2 — green
  "linear-gradient(135deg,#fcd34d,#f97316)",   // 3 — amber
  "linear-gradient(135deg,#93c5fd,#6366f1)",   // 4 — indigo
  "linear-gradient(135deg,#f9a8d4,#ec4899)",   // 5 — pink
  "linear-gradient(135deg,#6ee7b7,#0891b2)",   // 6 — teal
  "linear-gradient(135deg,#fde68a,#f59e0b)",   // 7 — yellow
  "linear-gradient(135deg,#fdba74,#be123c)",   // 8 — rose
  "linear-gradient(135deg,#c4b5fd,#7c3aed)",   // 9 — violet
  "linear-gradient(135deg,#fdba74,#ea580c)",   // 10 — orange
  "linear-gradient(135deg,#86efac,#0891b2)",   // 11 — green-teal
];

export const CATEGORY_ICONS = {
  // People & Admin
  "user":               "fa-user",
  "maid":               "fa-female",
  "waiter":             "fa-cutlery",
  "car driver":         "fa-car",
  "property agent":     "fa-home",
  "group":              "fa-group",

  // Construction & Civil
  "carpenter":          "fa-gavel",
  "plumber":            "fa-tint",
  "electrician":        "fa-bolt",
  "painter":            "fa-paint-brush",
  "interior":           "fa-building",
  "exterior":           "fa-building-o",
  "grill":              "fa-th",
  "sliding":            "fa-columns",
  "civil":              "fa-university",
  "wooden frame":       "fa-picture-o",

  // Appliance Technicians
  "washing machine":    "fa-refresh",
  "airconditioner":     "fa-snowflake-o",
  "fridge":             "fa-cube",
  "water filter":       "fa-filter",
  "gas":                "fa-fire",
  "stove":              "fa-fire",
  "led":                "fa-tv",
  "tv":                 "fa-tv",
  "computer":           "fa-laptop",
  "laptop":             "fa-laptop",
  "cctv":               "fa-video-camera",

  // Beauty & Wellness
  "mehendi":            "fa-hand-paper-o",
  "makeup":             "fa-magic",
  "hair":               "fa-scissors",
  "tattoo":             "fa-pencil",
  "yoga":               "fa-heart",
  "tailor":             "fa-scissors",
  "fashion":            "fa-tag",
  "embroidery":         "fa-star",

  // Events & Entertainment
  "event anchor":       "fa-microphone",
  "event management":   "fa-calendar",
  "dj":                 "fa-music",
  "music":              "fa-music",
  "choreographer":      "fa-music",
  "dance":              "fa-music",
  "magic":              "fa-magic",
  "balloons":           "fa-circle",
  "decorator":          "fa-star",

  // Media & Creative
  "photographer":       "fa-camera",
  "videographer":       "fa-video-camera",
  "video editor":       "fa-film",
  "drawing":            "fa-paint-brush",

  // Education
  "tuition":            "fa-book",
  "teacher":            "fa-graduation-cap",

  // Services
  "laundry":            "fa-tint",
  "pest control":       "fa-bug",
  "sofa":               "fa-couch",
  "mattress":           "fa-bed",
  "scrap":              "fa-recycle",
  "bhangarwala":        "fa-recycle",
};

export const getCategoryIcon = (name = "") => {
  const lower = name.toLowerCase();
  const key = Object.keys(CATEGORY_ICONS).find(k => lower.includes(k));
  return CATEGORY_ICONS[key] || "fa-briefcase";
};

export const getCategoryGradient = (idx = 0) =>
{
  return CATEGORY_GRADIENTS[idx % CATEGORY_GRADIENTS.length];
}

export const getCategoryColor = (idx = 0) =>
{
  return CATEGORY_COLORS[idx % CATEGORY_COLORS.length];
}
